import { graphql } from '../../../gql';

export const MY_VOUCHING_CREDITS_QUERY = graphql(`
  query myVouchingCredits {
    myVouchingCredits { available committed }
  }
`);
